document.addEventListener('click', (event) => {
    // Do nothing if 'click' was invoked by keyboard.
    if (event.screenX === 0 && event.screenY === 0) {
        return
    }

    // In older browsers (eg. IE11), there's no .closest(). Check it first.
    if (typeof event.target.closest !== 'function') {
        return
    }

    const elements = ['a', 'button', 'input[type="checkbox"]', 'input[type="radio"]']
    const buttonOrLink = event.target.closest(elements.join(', '))
    if (buttonOrLink) {
        buttonOrLink.blur()
    }
})
